import { render, staticRenderFns } from "./ForwardReplyMessageToTargetActionSetupView.vue?vue&type=template&id=60ed350c&scoped=true&"
import script from "./ForwardReplyMessageToTargetActionSetupView.vue?vue&type=script&lang=ts&"
export * from "./ForwardReplyMessageToTargetActionSetupView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ed350c",
  null
  
)

export default component.exports